var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerPaleGreenMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 208,
    viewBox: "0 0 343 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_552_7351)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 208,
    fill: "#B5DDD6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_552_7351)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-55.2213 41.6002C-23.4585 41.6002 2.29025 15.8118 2.29025 -15.9998C2.29025 -47.8114 -23.4585 -73.5998 -55.2213 -73.5998C-86.984 -73.5998 -112.733 -47.8114 -112.733 -15.9998C-112.733 15.8118 -86.984 41.6002 -55.2213 41.6002ZM-55.2213 60.8002C-12.871 60.8002 21.4608 26.4157 21.4608 -15.9998C21.4608 -58.4153 -12.871 -92.7998 -55.2213 -92.7998C-97.5716 -92.7998 -131.903 -58.4153 -131.903 -15.9998C-131.903 26.4157 -97.5716 60.8002 -55.2213 60.8002Z",
    fill: "#CEFFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0728 59.5151C10.6384 57.7588 4.81308 60.7417 3.06162 66.1777L-2.20654 82.5285C-3.958 87.9645 -0.972363 93.795 4.46205 95.5514L20.7632 100.82C26.1977 102.576 32.023 99.5931 33.7744 94.1571L39.0426 77.8063C40.794 72.3703 37.8084 66.5398 32.374 64.7834L16.0728 59.5151Z",
    fill: "#B5F6EC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_552_7351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 208,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_552_7351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287.558,
    height: 240,
    fill: "white",
    transform: "translate(-199 -16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerPaleGreenMobile);
export default __webpack_public_path__ + "static/media/banner-pale-green-mobile.5aa41a3c60e8e18d32dafa791189021c.svg";
export { ForwardRef as ReactComponent };